import { __assign, __extends } from "tslib";
import React from 'react';
import shortenNumber from '../../utils/shortenNumber';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { URLS } from '@wix/da-url/dist/src/constants';
import Logo from '../../Logo';
import { withThemeContext } from '../../Context';
import SearchIcon from '../../Icons/Search';
import CartIcon from '../../Icons/Cart';
import MessageIcon from '../../Icons/Message';
import { IconSize } from '../../Icons/IconWrap';
import SubmitMenu from './SubmitMenu';
import StandardMenu from '../../Dropdown/Preset/StandardMenu';
import UserDropdownMenu from './UserDropdownMenu';
import NotificationsDropdown from './NotificationsDropdown';
import Sticky from '../../Sticky';
import SearchPopup from '../_partials/SearchPopup/SearchPopup';
import ErrorBoundary from '../../ErrorBoundary';
import BiLink from '../../biLogger/Components/BiLink';
import BiButton from '../../biLogger/Components/BiButton';
import { BiEventType, BiDataHook, ReferralType, } from '../../biLogger/constants';
import VersionToggle from '../_partials/VersionToggle';
import { withVerification, } from '../../VerificationPopup/withVerification';
import withFeatureFlags from '../../redux/flags/withFeatureFlags';
import Flag from '../../redux/flags/Flag';
import DealerAd from '../../DealerAd';
import s from './SiteHeader.scss';
var OPEN_NOTIFICATIONS_DROPDOWN_TIMEOUT = 100;
var enhance = compose(withFeatureFlags, withVerification, withThemeContext, withTranslation());
var SiteHeaderDesktop = /** @class */ (function (_super) {
    __extends(SiteHeaderDesktop, _super);
    function SiteHeaderDesktop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSearchButtonClick = function () {
            var _a = _this.props, isSearchPopupShown = _a.isSearchPopupShown, openSearchPopup = _a.openSearchPopup;
            var isSearchPage = window.location.pathname.startsWith('/search');
            if (!isSearchPage) {
                if (!isSearchPopupShown) {
                    openSearchPopup();
                }
            }
            else {
                _this.props.onSiteHeaderSearchButtonClicked &&
                    _this.props.onSiteHeaderSearchButtonClicked();
            }
        };
        _this.limitNumber = function (number) {
            return number > 999 ? shortenNumber(number, 0, Math.floor) : "" + number;
        };
        _this.handleNotificationsDropdownHover = function () {
            _this.openNotificationsDropdownTimerId = window.setTimeout(_this.props.openNotificationsDropdown, OPEN_NOTIFICATIONS_DROPDOWN_TIMEOUT);
            window.clearTimeout(_this.closeNotificationsDropdownTimerId);
        };
        _this.handleNotificationsDropdownLeave = function () {
            window.clearTimeout(_this.openNotificationsDropdownTimerId);
            _this.props.closeNotificationsDropdown();
        };
        return _this;
    }
    SiteHeaderDesktop.prototype.renderResponsiveMenuItems = function () {
        var _this = this;
        var _a = this.props, activeMainMenuItem = _a.activeMainMenuItem, watchCount = _a.watchCount, t = _a.t, isLoggedIn = _a.isLoggedIn;
        var menu = [
            {
                key: 'browse',
                url: Url.browseHomeLink(),
            },
            {
                key: 'watch',
                notification: watchCount > 0,
                loggedInOnly: true,
                url: Url.watchLink(),
            },
            {
                key: 'shop',
                url: URLS.SHOP,
            },
            {
                key: 'groups',
                url: URLS.GROUPS,
            },
            {
                key: 'forum',
                url: URLS.FORUM,
            },
        ];
        var basicMenu = menu.slice(0, 2);
        var moreMenu = menu.slice(2, menu.length);
        return (React.createElement("div", { className: s['nav-list-container'] },
            React.createElement("ul", { className: s['nav-list'] },
                basicMenu.map(function (menuItem, index) {
                    return menuItem.loggedInOnly && !isLoggedIn ? null : (React.createElement("li", { key: menuItem.key, className: classnames(s['nav-list__item'], s["nav-list__item-" + menuItem.key]) },
                        React.createElement(BiLink, { biData: _this.getMenuItemBiData(menuItem), className: classnames(s['nav-list__item__link'], menuItem.key === activeMainMenuItem && s['active'], menuItem.notification && s['notification']), href: menuItem.url }, t("siteHeader." + menuItem.key))));
                }),
                React.createElement("li", { className: classnames(s['nav-list__item'], s['nav-list__item--more']) },
                    React.createElement("span", { className: s['nav-list__item__link'] }, t('siteHeader.more')),
                    React.createElement(StandardMenu, { lightText: true, className: s['more-list'], itemClassName: s['more-list__item'], items: moreMenu
                            .filter(function (menuItem) { return isLoggedIn || !menuItem.loggedInOnly; })
                            .map(function (menuItem) { return ({
                            link: menuItem.url,
                            label: t("siteHeader." + menuItem.key),
                            className: classnames(s["more-list__item-" + menuItem.key], menuItem.notification && s['notification']),
                            biData: _this.getMenuItemBiData(menuItem),
                        }); }) })))));
    };
    SiteHeaderDesktop.prototype.renderNotesIcon = function () {
        var noteCount = this.props.noteCount;
        return (React.createElement("span", null,
            React.createElement(MessageIcon, { size: IconSize.MEDIUM, className: s['envelope-icon'] }),
            noteCount > 0 && (React.createElement("span", { className: s['number'] }, this.limitNumber(noteCount)))));
    };
    SiteHeaderDesktop.prototype.renderSearchbar = function () {
        var t = this.props.t;
        return (React.createElement("div", { className: s['searchbar-container'] },
            React.createElement(BiButton, { biData: {
                    evid: BiEventType.TOP_NAV_CLICK,
                    link_name: 'search',
                }, className: classnames('ignore-react-onclickoutside', s['icon-button-searchbar']), onClick: this.handleSearchButtonClick, "aria-label": t('siteHeader.search.a11y.openSearchDialog') },
                React.createElement(SearchIcon, { className: s['search-icon'], size: IconSize.MEDIUM }),
                React.createElement("span", { className: s['search-label'] }, t('siteHeader.search')))));
    };
    SiteHeaderDesktop.prototype.renderIconButtonsBlock = function () {
        var _a = this.props, isLoggedIn = _a.isLoggedIn, cartCount = _a.cartCount, noteCount = _a.noteCount, feedbackCount = _a.feedbackCount, disableVersionSwitcher = _a.disableVersionSwitcher, switchVersion = _a.switchVersion, isVerificationNeeded = _a.isVerificationNeeded, pushVerificationPopup = _a.pushVerificationPopup, isNotificationsDropdownOpen = _a.isNotificationsDropdownOpen, t = _a.t;
        return (React.createElement("div", { className: s['icon-buttons-block'] },
            React.createElement(Flag, { condition: "header_ad" },
                React.createElement(DealerAd, { realEstateId: "9c14ea7a-8c35-429a-9857-00ad04ebb4c1", className: s['ad-slot'] })),
            !disableVersionSwitcher && (React.createElement("div", { className: s['version-switcher'] },
                React.createElement(VersionToggle, { onToggle: switchVersion }),
                React.createElement("div", { className: s['separator'] }))),
            cartCount > 0 && (React.createElement(BiLink, { biData: {
                    evid: BiEventType.TOP_NAV_CLICK,
                    link_url: URLS.CART,
                    link_name: 'cart',
                    indicator: cartCount,
                }, className: s['out-of-menu-link'], href: URLS.CART, "aria-label": t('siteHeader.a11y.cart.withItems', {
                    formattedCount: this.limitNumber(cartCount),
                }) },
                React.createElement("span", null,
                    React.createElement(CartIcon, { size: IconSize.MEDIUM, className: s['cart-icon'] }),
                    React.createElement("span", { className: classnames(s['number'], s['number-label__green']) }, this.limitNumber(cartCount))))),
            isLoggedIn &&
                (isVerificationNeeded ? (React.createElement(BiButton, { biData: {
                        evid: BiEventType.TOP_NAV_CLICK,
                        link_url: URLS.NOTES,
                        link_name: 'notes',
                        indicator: noteCount,
                    }, className: classnames(s['needs-verification-button'], s['out-of-menu-link'], s['icon-button-has-submenu']), onClick: function () { return pushVerificationPopup('notes'); }, "aria-label": t('siteHeader.a11y.openAccountVerificationDialog') }, this.renderNotesIcon())) : (React.createElement(BiLink, { biData: {
                        evid: BiEventType.TOP_NAV_CLICK,
                        link_url: URLS.NOTES,
                        link_name: 'notes',
                        indicator: noteCount,
                    }, className: classnames(s['out-of-menu-link'], s['icon-button-has-submenu']), "aria-label": t(noteCount > 0
                        ? 'siteHeader.a11y.notes.withItems'
                        : 'siteHeader.a11y.notes.withoutItems', {
                        formattedCount: this.limitNumber(noteCount),
                    }), href: URLS.NOTES }, this.renderNotesIcon()))),
            isLoggedIn && (React.createElement(NotificationsDropdown, { feedbackCount: this.limitNumber(feedbackCount), isOpen: isNotificationsDropdownOpen, onMouseEnter: this.handleNotificationsDropdownHover, onMouseLeave: this.handleNotificationsDropdownLeave, onTouchEnd: this.handleNotificationsDropdownTouch.bind(this), href: Url.feedbackLink(), "aria-label": t(feedbackCount
                    ? 'siteHeader.a11y.notifications.withItems'
                    : 'siteHeader.a11y.notifications.withoutItems', {
                    formattedCount: this.limitNumber(feedbackCount),
                }), biData: {
                    evid: BiEventType.TOP_NAV_CLICK,
                    link_name: 'notifications',
                    indicator: feedbackCount,
                } })),
            !isLoggedIn && (React.createElement(BiLink, { biData: {
                    evid: BiEventType.REDIRECT_TO_LOGIN,
                    referral_info: ReferralType.HEADER,
                }, className: s['out-of-menu-button'], href: Url.joinLink() }, t('siteHeader.join'))),
            !isLoggedIn && (React.createElement(BiLink, { biData: {
                    evid: BiEventType.TOP_NAV_CLICK,
                    link_url: Url.loginLink(),
                    link_name: 'login',
                }, className: s['out-of-menu-button'], href: Url.loginLink() }, t('siteHeader.signIn')))));
    };
    SiteHeaderDesktop.prototype.render = function () {
        var _a = this.props, environment = _a.environment, disableThemeSwitcher = _a.disableThemeSwitcher, isLegacyHeader = _a.isLegacyHeader, theme = _a.theme, isSearchPopupShown = _a.isSearchPopupShown, isUserDropdownOpen = _a.isUserDropdownOpen, closeSearchPopup = _a.closeSearchPopup, flags = _a.flags, t = _a.t;
        var shouldShowEnv = environment && ['rc', 'dev'].includes(environment);
        var isDarkTheme = theme === 'dark';
        return (React.createElement(ErrorBoundary, { className: s['root'] },
            React.createElement("header", { role: "banner", className: s['root'], "data-hook": BiDataHook.TOP_NAV },
                shouldShowEnv && (React.createElement("div", { className: s['env'] }, String(environment).toUpperCase())),
                React.createElement(BiLink, { biData: {
                        evid: BiEventType.TOP_NAV_CLICK,
                        link_url: URLS.ROOT,
                        link_name: 'logo',
                    }, href: URLS.ROOT, "aria-label": t('siteHeader.a11y.home') },
                    React.createElement(Logo, { className: s['logo'], textColor: isDarkTheme ? 'white' : 'black', size: "tiny" })),
                React.createElement("div", { className: s['with-separators'] },
                    this.renderResponsiveMenuItems(),
                    this.renderSearchbar(),
                    this.renderIconButtonsBlock(),
                    React.createElement(UserDropdownMenu, { isOpen: isUserDropdownOpen, className: s['icon-submenu'], disableThemeSwitcher: disableThemeSwitcher, isLegacyHeader: isLegacyHeader, flags: flags })),
                React.createElement(SubmitMenu, { isOpen: true, className: s['icon-button-has-submenu'], menuClassName: s['icon-submenu'], isLegacyHeader: isLegacyHeader })),
            isSearchPopupShown && (React.createElement(SearchPopup, { onClose: closeSearchPopup, isLegacyHeader: isLegacyHeader, isMobile: false }))));
    };
    SiteHeaderDesktop.prototype.handleNotificationsDropdownTouch = function (e) {
        e.preventDefault();
        this.handleNotificationsDropdownHover();
    };
    SiteHeaderDesktop.prototype.getMenuItemBiData = function (menuItem) {
        return {
            evid: BiEventType.TOP_NAV_CLICK,
            link_url: menuItem.url,
            link_name: menuItem.key,
            indicator: typeof menuItem.notification !== 'undefined'
                ? Number(menuItem.notification)
                : undefined,
        };
    };
    return SiteHeaderDesktop;
}(React.PureComponent));
export { SiteHeaderDesktop };
var StickySiteHeaderDesktop = /** @class */ (function (_super) {
    __extends(StickySiteHeaderDesktop, _super);
    function StickySiteHeaderDesktop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StickySiteHeaderDesktop.prototype.render = function () {
        var _this = this;
        var zIndex = +s['zIndex'];
        return (React.createElement(Sticky, __assign({}, (!Number.isNaN(zIndex) && { zIndex: zIndex })), function (isStuck) {
            return React.createElement(SiteHeaderDesktop, __assign({}, _this.props));
        }));
    };
    return StickySiteHeaderDesktop;
}(React.Component));
export { StickySiteHeaderDesktop };
export default enhance(StickySiteHeaderDesktop);
//# sourceMappingURL=SiteHeaderDesktop.js.map